import { Node } from '@tiptap/core';

/**
 * PageBreakExtension — inserts a manual page break node.
 * On-screen: dashed divider with label.
 * Print: page-break-after: always.
 */
export const PageBreakExtension = Node.create({
  name: 'pageBreak',

  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  parseHTML() {
    return [{ tag: 'div[data-type="page-break"]' }];
  },

  renderHTML() {
    return ['div', { 'data-type': 'page-break', class: 'page-break-node' }, '— Page Break —'];
  },

  addCommands() {
    return {
      insertPageBreak: () => ({ chain }) => {
        return chain()
          .insertContent({ type: this.name })
          .run();
      },
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => this.editor.commands.insertPageBreak(),
    };
  },
});
